import React, { type JSX } from 'react'
import { RichText } from '~/components/contentful/ContentfulRichText'
import Hero from '~/components/shared/Hero/HeroLegacy'
import { useStaticPageContent } from '~/hooks/useStaticPageContent/useStaticPageContent'
import { getHeroWithVariant } from '~/components/shared/Hero/HeroLegacy/getHeroWithVariant'
import SpinnerOverlay from '../SpinnerOverlay'
import AccordionItem from '../AccordionItem'
import styles from './PolicyPage.module.scss'

interface Policy {
  policyPage: string
  children?: JSX.Element
}

export default function PolicyPage({ policyPage, children }: Policy): JSX.Element {
  const data = useStaticPageContent(policyPage)

  if (data.isLoading) {
    return <SpinnerOverlay />
  }

  const { hero, content, thumbnail, accordionCollection } = data || {}

  const selectedHero = getHeroWithVariant(hero)
  const heroAlt = selectedHero?.image?.title || selectedHero?.heading || ''

  return (
    <>
      {selectedHero?.image?.file?.url && (
        <Hero src={selectedHero?.image.file.url} alt={heroAlt}>
          <Hero.Headline>{selectedHero?.heading ?? ''}</Hero.Headline>
        </Hero>
      )}
      <div className={styles.container}>
        {thumbnail ? (
          <div className={styles.thumbnail}>
            <p>{thumbnail}</p>
          </div>
        ) : null}
        {content ? (
          <RichText document={content} openLinksInNewTab sizes={{ h2: 'sm', h3: 'xs', h4: 'xs' }} />
        ) : null}
        {children}
        {accordionCollection?.length ? (
          <div className={styles.accordion}>
            {accordionCollection.map((item) =>
              item.accordionButton && item.accordionPanel ? (
                <AccordionItem
                  id={item.accordionButton}
                  key={item.accordionButton}
                  title={item.accordionButton}
                  content={item.accordionPanel}
                />
              ) : null
            )}
          </div>
        ) : null}
      </div>
    </>
  )
}
